const STATS = [
    { value: "142", label: "Sitios activos", testid: "stat-sites" },
    { value: "99.98%", label: "Uptime promedio", testid: "stat-uptime" },
    { value: "24/7", label: "Centro de respuesta", testid: "stat-247" },
    { value: "<30m", label: "Tiempo de respuesta SLA", testid: "stat-sla" },
];

const Stats = () => {
    return (
        <section
            data-testid="stats-section"
            className="border-b border-white/10 bg-[#0a0a0a]"
        >
            <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-white/10">
                {STATS.map((s) => (
                    <div
                        key={s.testid}
                        data-testid={s.testid}
                        className="p-8 md:p-12 lg:p-16 group hover:bg-[#1A9EC9] transition-colors"
                    >
                        <div className="font-display text-5xl md:text-7xl lg:text-8xl text-white group-hover:text-black leading-none tracking-tighter">
                            {s.value}
                        </div>
                        <div className="mt-6 font-mono text-[10px] md:text-xs tracking-[0.3em] uppercase text-white/50 group-hover:text-black">
                            {s.label}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Stats;
